<ng-container *ngIf="testimonial">
  <ng-container *ngIf="isMobileOrTablet$ | async; else testimonialDesktop">
    <h2 class="cej-testimonial-title">{{ testimonial.title }}&nbsp;:</h2>
    <article class="cej-testimonial-card" [class.cej-testimonial-card--odd]="isOdd">
      <div class="cej-testimonial-card__header" [class.cej-testimonial-card--odd__header]="isOdd">
        <img
          class="cej-testimonial-card__header__illustration"
          [class.cej-testimonial-card--odd__header__illustration]="isOdd"
          [src]="testimonial.illustration.src | imaginarySrc: 1:120"
          [srcset]="testimonial.illustration.src | imaginarySrc: 4:120"
          alt=""
        />
        <div class="cej-testimonial-card__header__content" [class.cej-testimonial-card--odd__header__content]="isOdd">
          <h3 class="cej-testimonial-card__header__title">{{ testimonial.who }}</h3>
          <ul class="cej-testimonial-card__header__list">
            <li *ngFor="let situation of testimonial.situation; trackBy: trackBySituation">
              {{ situation }}
            </li>
          </ul>
        </div>
      </div>
      <div class="cej-testimonial-card__content">
        <h4 class="cej-testimonial-card__content__title">{{ testimonial.solutionTitle }}</h4>
        <ul class="cej-testimonial-card__content__list">
          <li
            class="cej-testimonial-card__content__list__item"
            *ngFor="let proposition of testimonial.propositions; trackBy: trackBySolution"
          >
            {{ proposition }}
          </li>
          <li *ngIf="testimonial.goal as goal" class="cej-testimonial-card__content__list__item">
            <p><strong>Objectif&nbsp;: </strong>{{ goal }}</p>
          </li>
        </ul>
      </div>
    </article>
  </ng-container>
</ng-container>

<ng-template #testimonialDesktop>
  <article class="cej-testimonial-desktop" [class.cej-testimonial-desktop--odd]="isOdd">
    <h2 class="cej-testimonial-desktop__title" [class.cej-testimonial-desktop--odd__title]="isOdd">
      {{ testimonial.title }}&nbsp;:
    </h2>
    <img
      class="cej-testimonial-desktop__illustration"
      [class.cej-testimonial-desktop--odd__illustration]="isOdd"
      [src]="testimonial.illustration.src | imaginarySrc: 1:testimonial.illustration.width"
      [srcset]="testimonial.illustration.src | imaginarySrc: 4:testimonial.illustration.width"
      alt=""
    />
    <div class="cej-testimonial-desktop__content" [class.cej-testimonial-desktop--odd__content]="isOdd">
      <h3 class="cej-testimonial-desktop__content__title">{{ testimonial.who }}</h3>
      <ul class="cej-testimonial-desktop__content__situations">
        <li *ngFor="let situation of testimonial.situation; trackBy: trackBySituation">
          {{ situation }}
        </li>
      </ul>
    </div>
    <div class="cej-testimonial-desktop__solutions" [class.cej-testimonial-desktop--odd__solutions]="isOdd">
      <h4>{{ testimonial.solutionTitle }}</h4>
      <ul class="cej-testimonial-desktop__solutions__list">
        <li
          class="cej-testimonial-desktop__solutions__list__item"
          *ngFor="let proposition of testimonial.propositions; trackBy: trackBySolution"
        >
          {{ proposition }}
        </li>
        <li *ngIf="testimonial.goal as goal" class="cej-testimonial-desktop__solutions__list__item">
          <p><strong>Objectif&nbsp;: </strong>{{ goal }}</p>
        </li>
      </ul>
    </div>
  </article>
</ng-template>
